import { useMemo, useState } from 'react'
import {
  deleteTransportadora,
  getTransportadoras,
} from '../../../../services/api/https/registration/transportadora.http'
import { errorHandler } from '../../../../services/util/error.service'
import { gerarArquivoExcel } from '../../../../services/util/excel.service'

export const LOAD_MESSAGE = {
  NONE: 'NONE',
  INITIAL_FETCH: 'Adquirindo transportadoras',
  DELETE_TRANSPORTADORA: 'Apagando transportadora',
  SUCCESS_DELETE: 'Transportadora apagada com sucesso',
}

const INITIAL_STATE = {
  showModal: false,
  globalFilter: '',
  selectedTransportadora: null,
  transportadoras: [],
  loadingMessage: LOAD_MESSAGE.NONE,
  errorMessage: null,
}

export default function useTransportadora() {
  const [state, setState] = useState({ ...INITIAL_STATE })

  const localDispatch = useMemo(() => {
    //Helpers

    return {
      //Actions
      resetState() {
        setState(prevState => ({
          ...prevState,
          loadingMessage: LOAD_MESSAGE.NONE,
          errorMessage: null,
        }))
      },

      getTransportadoras(tpId) {
        if (tpId === 0) setState(prevState => ({ ...prevState, errorMessage: 'Selecione um TP' }))
        else
          getTransportadoras(tpId)
            .then(transportadoras =>
              setState(prevState => ({
                ...prevState,
                transportadoras: transportadoras,
                loadingMessage: LOAD_MESSAGE.NONE,
              })),
            )
            .catch(err =>
              setState(prevState => ({
                ...prevState,
                errorMessage: errorHandler(err),
                loadingMessage: LOAD_MESSAGE.NONE,
              })),
            )
      },

      deleteTransportadora(transportadoraId, tpId) {
        deleteTransportadora(tpId, transportadoraId)
          .then(() => {
            setState(prevState => {
              prevState.transportadoras = prevState.transportadoras.filter(
                transportadora => transportadora.id !== transportadoraId,
              )
              prevState.loadingMessage = LOAD_MESSAGE.SUCCESS_DELETE
              return { ...prevState }
            })
          })
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              errorMessage: errorHandler(err),
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
      },

      //Events
      onInit() {
        setState(prevState => ({ ...prevState, loadingMessage: LOAD_MESSAGE.INITIAL_FETCH }))
      },

      onMenuItemClicked(item, transportadora) {
        switch (item) {
          case 'Editar':
            setState(prevState => ({
              ...prevState,
              showModal: true,
              selectedTransportadora: transportadora,
            }))
            break

          case 'Apagar':
            setState(prevState => ({
              ...prevState,
              loadingMessage: LOAD_MESSAGE.DELETE_TRANSPORTADORA,
              selectedTransportadora: transportadora,
            }))
            break

          default:
            break
        }
      },

      onInputFilter(value) {
        setState(prevState => ({ ...prevState, globalFilter: value }))
      },

      onBtnNovo(selectedTp) {
        if (selectedTp !== 0) setState(prevState => ({ ...prevState, showModal: true }))
        else setState(prevState => ({ ...prevState, errorMessage: 'Selecione um TP' }))
      },

      onModalSave(transportadora) {
        setState(prevState => {
          const index = prevState.transportadoras.findIndex(
            transp => transp.id === transportadora[0].id,
          )
          if (index !== -1) {
            prevState.transportadoras[index] = transportadora[0]
          } else {
            prevState.transportadoras.push(transportadora[0])
          }
          prevState.showModal = false
          prevState.selectedTransportadora = null
          return { ...prevState }
        })
      },

      onModalClose() {
        setState(prevState => ({ ...prevState, showModal: false, selectedTransportadora: null }))
      },
      onBtnExportarExcelClick(transportadoras) {
        const colunas = [['Nome', 'CNPJ', 'Cidade', 'Estado', 'Ativo']]

        transportadoras.forEach(t => {
          colunas.push([t.nome, t.cnpj, t.city, t.state, t.actived ? 1 : 0])
        })

        gerarArquivoExcel('Transportadoras', colunas, 'transportadoras.xlsx')
      },
    }
  }, [])

  return { state, localDispatch }
}
